<template>
    <div class="box">
        <topBanner></topBanner>
        <div class="boxs">
            <img class="error" src="../../assets/img/404/404.png" alt="">
            <img class="back" @click="goHome" src="../../assets/img/404/home.png">
        </div>
        <end></end>
    </div>
</template>

<script>
import topBanner from "../../components/mobile_top.vue";
import end from "../../components/mobile_end.vue";
export default {
    name: "Error",

    components: {
        topBanner, end
    },
    data() {
        return {
        }
    },
    created() {
        setTimeout(() => {
            this.$router.push('/MobileHome')
        }, 3000);
    },
    methods: {
        goHome(){
            this.$router.push('/MobileHome')
        }
        
    },
    mounted() {

    },

};
</script>

<style lang="scss" scoped>
.boxs{
    width:100%;
    text-align:center;
    background:rgba(246, 248, 251, 1);
    height:50vh;
    padding-top:3rem;
}
.error{
    width:4.44rem
   }
   .back{
    width:4.2rem
   }
</style>